import { Col, Divider, Flex, Row } from 'antd';
import confirm from 'antd/es/modal/confirm';
import { useCallback, useEffect, useRef } from 'react';

import { RotateIcon, SwipeIcon } from '@suntex.fim/ui/icons';

import {
  getDeviceRotateConfirmed,
  setDeviceRotateConfirmed,
} from './deviceRotateState';

const MOBILE_WIDTH_THRESHOLD = 479;
const GUTTER_SIZE = 16;

export function useRotateDevice() {
  const hasConfirmed = useRef(false);
  const isModalOpen = useRef(false);

  const showConfirm = useCallback(() => {
    if (
      window.innerWidth < MOBILE_WIDTH_THRESHOLD &&
      !getDeviceRotateConfirmed() &&
      !hasConfirmed.current &&
      !isModalOpen.current
    ) {
      isModalOpen.current = true;
      confirm({
        className: 'rotate-notification',
        icon: null,
        content: (
          <Row gutter={[GUTTER_SIZE, GUTTER_SIZE]}>
            <Col span={11}>
              <Flex vertical align="center">
                <RotateIcon />
                <p className="fw-bold">Rotate Your Device</p>
              </Flex>
              <p
                className="rotate-notification-para"
                style={{ textAlign: 'center' }}
              >
                Please rotate your device for better viewing experience.
              </p>
            </Col>
            <Col span={2}>
              <Divider
                type="vertical"
                style={{ height: '100%', margin: '0 auto' }}
              />
            </Col>
            <Col span={11}>
              <Flex vertical align="center">
                <SwipeIcon />
                <p className="fw-bold">Swipe to Navigate</p>
              </Flex>
              <p
                className="rotate-notification-para"
                style={{ textAlign: 'center' }}
              >
                This page contains content that is horizontally scrollable.
              </p>
            </Col>
          </Row>
        ),
        onOk() {
          hasConfirmed.current = true;
          isModalOpen.current = false;
          setDeviceRotateConfirmed(true);
        },
        onCancel() {
          isModalOpen.current = false;
        },
        okButtonProps: {
          className: 'button button-primary button-medium button-round',
        },
      });
    }
  }, []);

  useEffect(() => {
    showConfirm();
    const handleResize = () => {
      if (window.innerWidth >= MOBILE_WIDTH_THRESHOLD) {
        hasConfirmed.current = false;
        setDeviceRotateConfirmed(false);
      }
      showConfirm();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [showConfirm]);
}
